<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-card title="Promocje" class="title-inline h-100">
          <div id="m-list" v-if="Object.keys(promotions).length !== 0">
            <b-card
              no-body
              class="my-2"
              v-for="(promotion, index) in filteredPromotions"
              :key="index"
            >
              <div class="promotion">
                <b-card-header header-tag="header" class="p-3">
                  <span class="pr-2 w-50" v-html="promotion.title"></span>
                </b-card-header>
                <b-card-body class="p-3">
                  <p v-html="promotion.description"></p>
                </b-card-body>
              </div>
            </b-card>
          </div>
          <div v-else>Brak dostępnych promocji</div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { skp_f, skp_b, skp_t, sam, sam_t, skp } from './config/promotions';
import moment from 'moment';
import { sam_plans, skp_plans } from './config/cloudPlans';

export default {
  name: 'Promotions',
  data() {
    return {
      currentCloud: false,
      osOldPrice: {},
      osPrice: {},
      osDiscount: {},
      cloudDiscount: {},
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      licence: 'auth/userLicence',
      client: 'auth/client',
      currentOs: 'auth/currentOs',
      isTestAccountRegistered: 'auth/isTestAccountRegistered',
      isTestAccountUnregistered: 'auth/isTestAccountunRegistered',
      cloudNeverHave2024: 'auth/cloudNeverHave2024',
      discounts: 'order/discounts',
    }),
    isAccountant() {
      return (
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('B')
      );
    },
    isDiscount656_657() {
      return typeof this.cloudDiscount === 'object' &&
        this.cloudDiscount !== null
        ? this.cloudDiscount.id === 656 || this.cloudDiscount.id === 657
        : false;
    },
    isDiscount654_655() {
      return typeof this.osDiscount === 'object' && this.osDiscount !== null
        ? this.osDiscount.id === 654 || this.osDiscount.id === 655
        : false;
    },
    isDiscountBlackMonthWithoutOs658() {
      return typeof this.osDiscount === 'object' && this.osDiscount !== null
        ? this.osDiscount.id === 658
        : false;
    },
    isDiscountBlackMonthWithOs616() {
      return this.isDiscountId(616);
    },
    promotions() {
      if (this.program === 'skp') {
        let filteredDiscountsDesc = this.promotionsSkp;
        filteredDiscountsDesc = filteredDiscountsDesc.concat(
          this.filterConditions(skp)
        );
        return filteredDiscountsDesc;
      }
      if (this.program === 'sam') {
        if (this.isTestAccountRegistered || this.isTestAccountUnregistered) {
          return sam_t;
        }
        return this.filterConditions(sam);
      }
      return {};
    },
    promotionsSkp() {
      if (this.isTestAccountRegistered || this.isTestAccountUnregistered) {
        return this.filterConditions(skp_t);
      }
      if (this.isAccountant) {
        if (
          this.client.DOD !== null &&
          this.client.DOD !== '' &&
          this.client.DOD.split('').includes('X')
        ) {
          return this.filterConditions(skp_b.filter((item) => item.id !== 602));
        }
        return this.filterConditions(skp_b);
      }
      if (
        this.client.DOD !== null &&
        this.client.DOD !== '' &&
        this.client.DOD.split('').includes('X')
      ) {
        return this.filterConditions(skp_b.filter((item) => item.id !== 601));
      }
      return this.filterConditions(skp_f);
    },
    filteredPromotions() {
      return this.promotions.filter((promotion) => {
        if (
          (promotion.id === 209 || promotion.id === 210) &&
          (!this.currentOs || !this.cloudNeverHave2024)
        ) {
          return false;
        }
        return true;
      });
    },
  },
  created() {
    this.getCurrentDiscounts();
    this.getCloudDataByClient();
    this.getOsPrice();
    this.$store.dispatch('auth/me');
    axios
      .get('/api/getCloudDiscount/' + this.program + '/' + this.licence)
      .then(({ data }) => {
        if (data) {
          this.cloudDiscount = data;
        }
      });
  },
  methods: {
    isDiscountId(id) {
      return !!this.discounts.find((discount) => discount.id === id);
    },
    getCurrentDiscounts() {
      this.loading = true;
      axios.get('/api/currentDiscounts/' + this.program).then(({ data }) => {
        if (data) {
          this.loading = false;
          let that = this;
          Object.values(data).forEach(function (item) {
            that.$store.commit('order/addDiscount', item);
          });
        }
      });
    },
    getCloudDataByClient() {
      axios
        .get('/api/getCloudDataByClient/' + this.program + '/' + this.licence)
        .then(({ data }) => {
          if (data.length > 0) {
            this.currentCloud = true;
          }
        });
    },
    getOsPrice() {
      this.loading = true;
      axios
        .get('/api/getOsPrice/' + this.program + '/' + this.licence)
        .then(({ data }) => {
          this.osOldPrice = data.osOldPrice;
          this.osPrice = data.osPrice;
          this.osDiscount = data.discount;
        });
    },
    filterConditions(promotions) {
      let that = this;
      let filtered = [];

      const isDiscount656_657 = this.isDiscount656_657;
      const isDiscount654_655 = this.isDiscount654_655;
      const isDiscountBlackMonthWithoutOs658 =
        this.isDiscountBlackMonthWithoutOs658;
      const isDiscountBlackMonthWithOs616 = this.isDiscountBlackMonthWithOs616;
      const isAccountant = this.isAccountant;
      promotions.forEach(function (promotion) {
        if (promotion.id === 'custom') {
          if (
            promotion.start <= moment().format('YYYY-MM-DD HH:ii:ss') &&
            promotion.end >= moment().format('YYYY-MM-DD HH:ii:ss') &&
            ((typeof promotion.os === 'boolean' &&
              !promotion.os &&
              !that.currentOs) ||
              (typeof promotion.os === 'boolean' &&
                promotion.os &&
                that.currentOs) ||
              typeof promotion.os !== 'boolean')
          ) {
            filtered.push(promotion);
          }
        } else if (promotion.id === 656 || promotion.id === 657) {
          if (isDiscount656_657) {
            filtered.push(promotion);
          }
        } else if (promotion.id === 654655) {
          if (isDiscount654_655) {
            filtered.push(promotion);
          }
        } else if (
          promotion.id === 658 &&
          isDiscountBlackMonthWithoutOs658 &&
          !that.currentOs
        ) {
          filtered.push(promotion);
        } else if (
          promotion.id === 6161 &&
          isDiscountBlackMonthWithOs616 &&
          that.currentOs &&
          !isAccountant
        ) {
          filtered.push(promotion);
        } else if (
          promotion.id === 6162 &&
          isDiscountBlackMonthWithOs616 &&
          that.currentOs &&
          isAccountant
        ) {
          filtered.push(promotion);
        } else if (promotion.id === 'cloud') {
          if (
            promotion.start <= moment().format('YYYY-MM-DD HH:ii:ss') &&
            promotion.end >= moment().format('YYYY-MM-DD HH:ii:ss') &&
            !that.currentCloud
          ) {
            filtered.push(promotion);
          }
        } else {
          if (
            typeof promotion.os === 'boolean' &&
            promotion.os &&
            that.currentOs
          ) {
            filtered.push(promotion);
          } else if (
            typeof promotion.os === 'boolean' &&
            !promotion.os &&
            !that.currentOs
          ) {
            filtered.push(promotion);
          } else if (
            typeof promotion.os === 'undefined' &&
            (typeof promotion.start === 'undefined' ||
              (typeof promotion.start !== 'undefined' &&
                promotion.start <= moment().format('YYYY-MM-DD HH:ii:ss') &&
                promotion.end >= moment().format('YYYY-MM-DD HH:ii:ss')))
          ) {
            filtered.push(promotion);
          }
        }
      });

      return filtered;
    },
  },
};
</script>

<style scoped>
::v-deep {
  font-family: Proxima0, sans-serif;
}
</style>
